import { IVisaPrepForm } from '../../../../../../types/index.d';
import { hasSpouseDetails, isPersonTravellingWith } from '../../../../../../utilities/pages';

type Fields = Pick<
  IVisaPrepForm,
  | 'maritalStatus'
  | 'spouseNationality'
  | 'spouseSameNationality'
  | 'spouseFamilyName'
  | 'spouseGivenName'
  | 'spouseLivingWith'
  | 'spouseTravellingWith'
  | 'spouseUkVisa'
  | 'spouseHasPassport'
  | 'spousePassportNumber'
  | 'spouseDob'
>;

type Params = Fields & {
  dobError: string;
};

export function getPageStatus({
  maritalStatus,
  spouseNationality,
  spouseSameNationality,
  spouseFamilyName,
  spouseGivenName,
  spouseLivingWith,
  spouseTravellingWith,
  spouseUkVisa,
  spouseHasPassport,
  spousePassportNumber,
  spouseDob,
  dobError
}: Params): { complete: boolean } {
  let complete = true;

  if (
    maritalStatus === undefined ||
    (hasSpouseDetails(maritalStatus) &&
      (spouseNationality === undefined ||
        spouseNationality === '' ||
        spouseSameNationality === undefined ||
        spouseFamilyName === undefined ||
        spouseFamilyName === '' ||
        spouseGivenName === undefined ||
        spouseGivenName === '' ||
        spouseDob === undefined ||
        spouseDob === '' ||
        spouseLivingWith === undefined ||
        spouseTravellingWith === undefined ||
        spouseTravellingWith === '' ||
        (isPersonTravellingWith(spouseTravellingWith) &&
          (spouseUkVisa === undefined ||
            spouseHasPassport === undefined ||
            (spouseHasPassport === true && (spousePassportNumber === undefined || spousePassportNumber === '')))) ||
        dobError !== ''))
  ) {
    complete = false;
  }

  return { complete };
}
